import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActiveVoucherComponent } from './active-voucher/active-voucher.component';
import { RedeemedVoucherComponent } from './redeemed-voucher/redeemed-voucher.component';
import { VouchersComponent } from './vouchers.component';


const routes: Routes = [
  {
    path: 'vouchers',
    data: { title: 'Vouchers'
  },
    children: [
      { path: '', component: VouchersComponent },
      {
          path: 'active-voucher',
          data: {
              title: 'Active Vouchers'
          },
          component: ActiveVoucherComponent
      },
      {
        path: 'redeemed-voucher',
        data: {
            title: 'Redeemed Vouchers'
        },
        component: RedeemedVoucherComponent
    }


    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VouchersRoutingModule { }
